/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAssessmentRunScan extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAssessmentRunScan");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAssessmentRunScan.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAssessmentRunScan>): BackgroundJobPayloadForAssessmentRunScan {
        let obj = Object.assign(new BackgroundJobPayloadForAssessmentRunScan(), model);
        BackgroundJobPayloadForAssessmentRunScan.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAssessmentRunScan>): BackgroundJobPayloadForAssessmentRunScan {
        if (!model) return null;
        return BackgroundJobPayloadForAssessmentRunScan.newInstance(<BackgroundJobPayloadForAssessmentRunScan> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAssessmentRunScan) {
        if (!obj) return;

        models.BackgroundJobPayloadForAssessmentRunScan.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAssessmentRunScan): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAssessmentRunScan.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * The assessment run history for this scan
     */
    assessment_run_history_id: string;

}
